<template>
  <div class="maincateContent">
    <div class="page-item">
            <div class="content">
              <div class="title">
                    {{mainCateTitle}}
                </div>
                <div class="tabnav">         
                    <ul v-if="!isShowMoreBrand">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in showBrandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="!isShowMoreBrand" class="showmore" @click="setBrandShow(true)">展开<i class="icon icon-list" ></i></a>
                    <ul v-if="isShowMoreBrand" style="flex-wrap:wrap">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in brandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="isShowMoreBrand" class="showmore" @click="setBrandShow(false)">收缩<i class="icon icon-list1"></i></a>
                </div>          
                <div class="tabcontent" v-loading="loading" element-loading-text="加载中...">
                    <ul>
                        <li v-for="(item,i) in goods" :key="i">
                                <div class="productIamge">
                                  <img :src="item.defaultImage" @click="toDetail(item.id)"/>
                                  <img class="productIcon" v-for="(labelItem,labelIndex) in item.labels" v-if="labelIndex<1&&labelItem.labelIcon" :key="labelIndex" :src="labelItem.labelIcon" />
                                </div>
                                <div class="productname">
                                    {{item.name}}
                                </div>
                                <div class="productprice">
                                    <span class="price">
                                      ￥{{item.settlementPrice}}
                                      <span class="scribe" v-if="item.settlementPrice<item.sellPrice">
                                        ￥{{item.sellPrice}}
                                    </span>
                                    </span>
                                   
                                    <span class="sales">
                                        成交{{item.sales}}件
                                     </span>
                                </div>                          
                            <div class="operationBtn">
                              <a  @click="toDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                              <y-button text="加入购物车"
                                @btnClick="showModal(item)"
                                classStyle="main-btn"
                              ></y-button>
                            </div>
                        </li>                       
                    </ul>                    
                </div>
                <el-pagination
                      v-if="!noResult&&!error"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      @size-change="handleSizeChange"
                      :current-page.sync="currentPage3"
                      layout="prev, pager, next, jumper"
                      :total="goodsTotal">
                    </el-pagination>
            </div>
          </div>        
        <selectSpec ref="selectSpec"></selectSpec>
  </div>
</template>
<style>
@import '../../styles/maincate.css';
</style>
<script>
  import api from '@/api'
  import mallGoods from '@/components/mallGoods'
  import YButton from '@/components/yButton'
  import YShelf from '@/components/shelf' 
  import SelectSpec from './components/SelectSpec' 
  import {mapGetters, mapActions,mapMutations} from 'vuex'
  export default {
    data () {
      return {
        isShowMoreBrand:false,
        brandMenuIndex:0,
        showSpecModal:false,
        mainCateTitle:'',    
        mainCateId:0,  
        error: false,
        loading: true,
        searching: true,
        sortType: null,
        sort: '',
        currentPage: 1,
        pageSize: 50,
        total: 0,
        key: '',
        brandList:[],
        showBrandList:[],
        brandId:0,
        keyType:0,
        sorting:'',
        sortAsc:false,
        currentPage3:1,
        productDetail:{}
      }
    },
    methods: {
      fetchData() {
        
      },
      showModal(item){      
        this.$refs['selectSpec'].showSelect(item)    
       },      
    
      handleSizeChange (val) {
        this.pageSize = val
        this._getSearch()
        this.loading = true
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._getSearch()
        this.loading = true
      },
      async _getSearch () {       
        let MaxResultCount =  this.pageSize
        let SkipCount = (this.currentPage - 1) * this.pageSize
        let params = {
            skipCount: SkipCount,
            maxResultCount: MaxResultCount,
            categoryId:0,
            brandId:this.brandId,
            sortAsc:this.sortAsc,
            sorting:this.sorting,
            name: this.key,
            SearchKeyType:this.keyType,
            mainCateTypeId:this.mainCateId
        }
        await this.loadGoodsList(params)
        this.loading = false
        this.searching = false
       
      }, 
      toDetail(id)
      {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      sortFun(val)
      {
         this.loading=true;
         this.currentPage = 1
         switch(val)
         {
            case 1:
              this.sortType = 1;
              this.sorting = '';
              this.sortAsc = false;
              break;
            case 2://价格升序
              this.sortType = 2;
              this.sorting = 'price';
              this.sortAsc = true;
              break;
            case 3://价格降序
              this.sortType = 3;
              this.sorting = 'price';
              this.sortAsc = false;
              break;
            case 4://销售降序            
              this.sortType = 4;
              this.sorting = 'sales';
              this.sortAsc = false;
              break;
            case 5://新品降序        
              this.sortType = 5;
              this.sorting = 'new';
              this.sortAsc = false;
              break;
         }
         this._getSearch();
      },         
      brandMenu(index)
      {
        if (this.brandMenuIndex === index) {
          return;
        }
        this.brandMenuIndex = index;
        this.loading=true;
        this.brandId=index;
        this.currentPage=1;
        this._getSearch();
      },
      setBrandShow(val)
      {
        this.isShowMoreBrand=val;
      },
      _getBrands() {
        var _this=this;
      api.get('api/services/app/CommonLookup/GetBrands').then(res => {
        _this.brandList = res.data.result.items
        _this.showBrandList=[];
          for(var i=0;i<_this.brandList.length&&i<12;i++)
          {
            _this.showBrandList.push(_this.brandList[i]);
          }
        })
      },
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      ...mapActions([
       'loadGoodsList',
      ])
    },
    created () {   
      if (this.$route.query.mainCateName) {
        let name = this.$route.query.mainCateName
        this.mainCateTitle = decodeURIComponent(name);      
      }     
      if(this.$route.query.mainCate)
      {
        this.mainCateId = parseInt(this.$route.query.mainCate)
      }
    },
    computed: {
      ...mapGetters([
        'goods',
        'goodsTotal',
        'noResult'
      ])
    },
    mounted () {
      this.key = this.$route.query.key
      this.keyType = this.keyType || 0
      this.sortType = this.$route.query.sort || 1;      
      this.sortType = parseInt(this.sortType);
      this.sortFun(this.sortType);
      this._getBrands()
    },
    components: {
      YButton,    
      YShelf,
      SelectSpec
    }
  }
</script>



// WEBPACK FOOTER //
// mainCate.vue?4451b220